/* global Poker, Promise, gtag */
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import cookies from 'js-cookie';

import { eventBus } from './state-manager/event-bus';
import { gameStarter } from './game-starter/index';
import { handleError, ERRORS } from './utils/handle-error';
import { openPopup } from './utils/open-popup';
// 공통 메시지
import { message } from './message/message-model';
import { MessageView } from './message/message-view';
// 게임 실행중
import { userGameStatus } from './game-starter/user-game-status-model';
// 유저 정보
import { userInfo } from './user-info/user-info-model';
import { UserInfoView } from './user-info/user-info-view';
// 피망 캐쉬 선물하기
import { GiftCashView } from './gift-cash/gift-cash-view';
// 레이어 팝업
import { PmlayerModel, getValueFromPmlayerDOM } from './pmlayer/pmlayer-model';
import { PmlayerView } from './pmlayer/pmlayer-view';
// 개인암호
import { PasswdModel } from './mfa/passwd/passwd-model';
import { PasswdView } from './mfa/passwd/passwd-view';
// 보안SMS
import { SecureSMSModel } from './mfa/secure-sms/secure-sms-model';
import { SecureSMSView } from './mfa/secure-sms/secure-sms-view';
// 하우PC방
import { HowPcbangModel } from './how-pcbang/how-pcbang-model';
import { HowPcbangView } from './how-pcbang/how-pcbang-view';
// 멤버십
import { MembershipView } from './membership/membership-view';
// 피망보너스
import { PmangBonusModel } from './bonus/pmbonus-model';
import { PmangBonusView } from './bonus/pmbonus-view';
// 채널
import { ChannelsModel } from './channels/channels-model';
// 정기결제
import { SubscriptionModel } from './membership/subscription-model';
import { SubscriptionView } from './membership/subscription-view';
// 현재 접속자 수
import { addComma } from './utils/number-format';
import { cuCounter } from './cu-counter';
import { createWebPushManager } from './fcm/web-push';

export var AppView = Backbone.View.extend({
  el: '.app__main',

  eventBus: eventBus,

  initialize: function () {
    _.bindAll(
      this,
      'checkMFA',
      'runGame',
      'openMall',
      'watchPopups',
      'popupOnClose',
      'openWindowPopup',
      'createLayerPopups'
    );
    this.state = this.model; // state는 AppView 생성 시 주입
    this.game = this.state.get('game'); // 영문 : 7poker
    this.gameName = this.state.get('gameName'); // 국문 : 7포커

    this.openedPopups = [];
    this.clearWatchPopup = _.noop;

    this.layerPopups = [];
    this.createLayerPopups();

    this.userInfo = null;
    this.userInfoView = null;

    this.membershipView = null;

    this.mallView = null;

    this.pmbonus = null;
    this.pmbonusView = null;

    this.channels = null;

    this.subscription = null;
    this.subscriptionView = null;

    this.message = message;
    this.messageView = new MessageView({ model: this.message });

    this.isLive = this.state.get('env') === 'live';

    this.isUnderMaintaining = this.state.get('maintenanceSsn') === this.state.get('ssn');

    // 포커 점검 일 경우 접속하자마자 점검 안내 메시지
    if (this.isUnderMaintaining) {
      var maintenanceError;
      maintenanceError = new Error('UnderMaintenanceError');
      maintenanceError.code = ERRORS.Maintenance; // 점검 중!
      handleError(maintenanceError);
    }

    if (this.state.get('loggedIn')) {
      // 유저 정보 모델
      this.userInfo = userInfo;
      this.userInfo.fetch({ game: this.game });
    }
    this.listenTo(this.userInfo, 'sync', this.onUserInfoUpdated);

    // 우측 사이드바 유저 영역
    if (this.$('.app__user-info').length > 0) {
      this.userInfoView = new UserInfoView({ model: this.userInfo });

      this.pmbonus = new PmangBonusModel();

      if (!this.state.get('maintenance') && this.game === 'sudda') {
        this.cuCounter = cuCounter;
        this.cuCounter.startPolling(this.game, 20, 15); // 20초에 한번 최대 15번까지만
        this.listenTo(this.cuCounter, 'change', this.renderCUCounter);
      }

      new GiftCashView();

      // Firebase 웹푸시, 오른쪽 사이드바가 있을 경우만, 7poker에서만
      if (this.game === '7poker' || this.game === 'sudda') {
        var envName = this.state.get('env').toUpperCase();
        var webPush = createWebPushManager(envName, this.game);

        webPush
          .requestPermission()
          .then((hasPermission) => {
            if (hasPermission) {
              return webPush.registerSubscription();
            }
            throw new Error('FCM Permission Denied');
          })
          .then((registered) => {
            if (registered) {
              console.log('FCM Registered');
              return webPush.addMessageHandler();
            }
          })
          .catch((error) => {
            console.log('FCM', error);
          });
      }
    }

    // 하우 PC방
    if (this.$('.app__how-pcbang').length > 0) {
      this.howPcbang = new HowPcbangModel();
      this.howPcbangView = new HowPcbangView({ model: this.howPcbang });
    }

    // 멤버십 페이지
    if (this.$('.app__membership').length > 0) {
      this.membershipView = new MembershipView({ model: this.userInfo });
    }

    // 정기결제
    if (this.$('.app__subscription-page').length > 0) {
      this.subscription = new SubscriptionModel();
      this.subscriptionView = new SubscriptionView({ model: this.subscription });
      this.$('.app__subscription-page').html(this.subscriptionView.el);
    }

    this.eventBus.on('app:refresh', this.refresh, this);
    this.eventBus.on('app:runGame', this.runGame, this);
    this.eventBus.on('app:authenticate', this.checkMFA, this);
    this.eventBus.on('app:isNewUser', this.isNewUser, this);
    this.eventBus.on('app:handleError', handleError, this);

    this.eventBus.on('open:popup', this.openWindowPopup, this);
    this.eventBus.on('open:mall', _.bind(this.openMall, this));
    // 2022년 10월 웹출석부 삭제
    // this.eventBus.on('open:attendance', _.bind(this.openAttendance, this));
    this.eventBus.on('open:transfer', _.bind(this.openAssetTransfer, this));
    this.eventBus.on('open:pmbonus', _.bind(this.openPmbonus, this));

    this.eventBus.on(
      'show:message',
      _.bind(function (e) {
        this.message.show(e.title, e.message, e.onConfirm, e.options);
      }, this)
    );
    this.eventBus.on(
      'show:maintenance',
      _.bind(function () {
        this.message.show('게임 점검 안내', [
          '지금은 게임 점검 중입니다.',
          '조금만 기다려 주세요',
          this.isLive
            ? ''
            : 'LIVE 환경이 아닐 경우 점검 메시지가 표시되더라도 게임 실행, 포커몰, 피망보너스, 자산이동이 가능합니다.'
        ]);
      }, this)
    );
    this.eventBus.on(
      'show:newUser',
      _.bind(function () {
        this.message.show('알림', '해당 기능은 게임 설치 후 이용 가능합니다.');
      }, this)
    );

    this.render(); // 메인 뷰 렌더링
  },

  events: {
    'click [data-app-role=runGame]': 'runGame',
    // 'click [data-app-role=openAttendance]': 'openAttendance',
    'click [data-app-role=openAssetTransfer]': 'openAssetTransfer',
    'click [data-app-role=openPmbonus]': 'openPmbonus',
    'click [data-app-role=openMall]': 'openMall',
    'click [data-app-link-type=I]': 'showPrelude',
    'click [data-app-link-type=OA]': 'showPrelude',
    'click [data-app-link-type=OW]': 'openNewWindow',
    'click [data-app-link-type=PS]': 'openMall',
    'click [data-app-link-type=OP]': 'openWindowPopup',
    'click [data-app-popup]': 'openWindowPopup',
    'click [data-app-logout]': 'logout',
    'click [data-app-action]': 'reportClickAction'
  },

  render: function () {
    // 왼쪽 스카이 배너중에 CPS 웹 무료충전소 배너를 찾아 팝업으로 연결
    this.$el.find('[data-app-banner-id]').each(
      _.bind(function (i, el) {
        var $bn = $(el);
        var href = $bn.attr('href');
        if (href && href.indexOf('/sponsorship/') < 1) return;

        var channelling = this.state.get('channelling');
        var gsn = this.state.get('gsn');
        var params = gsn + '&channelling=' + channelling;

        $bn.attr({
          href: href.replace(/\[GSN\]/, params),
          'data-app-popup': 'cps',
          'data-app-popup-width': 900,
          'data-app-popup-height': 660
        });

        $bn.on('click', _.bind(this.openWindowPopup, this));
      }, this)
    );

    return this;
  },

  renderCUCounter: function () {
    if (this.game === 'sudda') {
      // 섯다일때만 cu counter 활성화.
      var getCount = this.cuCounter.get('count');
      var count = getCount ? getCount.count : 0;
      if (!count) {
        count = 0;
      }
      var countWithComma = addComma(count);
      $('.game-start__status').html('현재 접속자 수 : ' + countWithComma + '명');
    }
  },

  refresh: function () {
    if (this.userInfo) {
      this.userInfo.refresh();
    }
  },

  onUserInfoUpdated: function () {
    if (this.membershipView) {
      this.membershipView.render();
    }

    // 채널 활성, 비활성화
    if ($('.nav-channel').length > 0) {
      this.channels = new ChannelsModel();
      this.channels
        .fetch()
        .then(_.bind(this.channels.parse, this))
        .done(function (chList) {
          $('[data-channel-id]').each(function (idx, el) {
            var $ch = $(el);
            var matched = _.find(chList, function (val) {
              return val.channelId === $ch.data('channelId');
            });

            if (!matched) { return } // prettier-ignore

            // 비활성 -> 활성
            if (matched.isActive) {
              $ch.data('appRole', 'runGame').parent().removeClass('off').addClass('on');
            } else {
              $ch.data('appRole', '').parent().removeClass('on').addClass('off');
            }
          });
        });
    }
  },

  openMall: function (e) {
    var $clicked;
    var isGift;
    var trackingCode;

    if (this.isNewUser()) return;

    if (this.checkMaintenance() && this.isLive) return;

    if (this.isGuest()) {
      this.login();
      return;
    }

    try {
      if (e && _.isFunction(e.preventDefault)) {
        e.preventDefault();
      }

      if (this.mallView) {
        this.mallView.remove();
        this.mallView.unbind();
      }

      $clicked = $(e.currentTarget);

      if ($clicked.data('trackingCode')) {
        trackingCode = $clicked.data('trackingCode');
      } else if (e && e.trackingCode) {
        trackingCode = e.trackingCode;
      } else {
        trackingCode = 'p|Shop_Web|0'; // default
      }

      if ($clicked.data('appLinkType') === 'PS') {
        // 배너에서 웹상점 링크. NIMS에서 설정한 경우.
        this.mallView = Poker.mall.init({
          trackingCode: trackingCode
        });
        location.hash = '#' + $clicked.attr('href');
      } else if ($clicked.data('goodsId')) {
        // 상품 구매하기 딥링크 클릭
        isGift = $clicked.data('goodsGift') || false;
        this.mallView = Poker.mall.init({
          goodsId: $clicked.data('goodsId'),
          gift: isGift,
          trackingCode: trackingCode
        });
      } else {
        this.mallView = Poker.mall.init({
          trackingCode: trackingCode
        });
      }

      // 프로그래밍 방식으로 호출 e.to에 링크를 넘겼을 경우
      if (e && e.to) {
        location.hash = '#' + e.to;
      }

      $('.app__poker-mall').append(this.mallView.el);
    } catch (err) {
      this.message.show('포커몰 오류', [
        '포커몰을 이용하실 수가 없습니다.',
        '잠시 후 다시 시도하시거나',
        '문제가 계속 되면 고객센터로 문의해주십시오.'
      ]);
      console.info('Poker.mall error occurred.', err.name, err.message);
    }
  },

  openAssetTransfer: function (e) {
    if (e && _.isFunction(e.preventDefault)) e.preventDefault();

    if (this.isNewUser()) return;

    if (this.checkMaintenance() && this.isLive) return;

    try {
      var $btn = $(e.target);

      // 현재 진행 중이면 버튼 다시 클릭해도 막음
      if ($btn.data('disabled')) return;

      /** @type {string} 'money' | 'pchip */
      var transferType = $btn.data('asset-transfer-type');

      // 오픈 전 AJAX 요청이 있으므로 여기서 버튼 클릭 불가로 설정
      $btn.data('disabled', true);

      // 게임 플레이 중 체크
      userGameStatus.checkPlaying(this.game).done(
        _.bind(function (isPlaying) {
          if (isPlaying) {
            $btn.data('disabled', false); // 버튼 클릭 가능하게
            this.message.show('안내', ['게임 실행 중에는', '자산 이동을 할 수 없습니다.']);
            return;
          } else {
            //게임 실행중 팝업이 소지 머니 체크  팝업보다 먼저 나와야 하는 팝업
            var currentAsset = this.userInfo.toJSON();
            var cannotTransferMoney = transferType === 'money' && currentAsset.money < 100000000000;
            var cannotTransferPchip = transferType === 'pchip' && currentAsset.pchip < 10000000;

            if (cannotTransferMoney) {
              this.message.show('머니 이동 불가', [
                '소지머니 1000억 골드 이상 시',
                '머니 이동이 가능합니다.'
              ]);
              return;
            } else if (cannotTransferPchip) {
              this.message.show('포커칩 이동 불가', [
                '포커칩 1000만 칩 이상 시',
                '포커칩 이동이 가능합니다.'
              ]);
              return;
            }
            Poker.assetTransfer.init(transferType);
            $btn.data('disabled', false); // 버튼 클릭 가능하게
          }
        }, this)
      );
    } catch (err) {
      this.message.show('안내', [
        '현재 자산 이동을 할 수 없습니다.',
        '잠시 후 다시 시도하시거나',
        '문제가 계속 되면 고객센터로 문의해주십시오.'
      ]);
      console.info('Poker.assetTransfer error occurred.', err.name, err.message);
    } finally {
      $btn.data('disabled', false);
    }
  },

  openPmbonus: function () {
    if (this.isNewUser()) return;

    if (this.checkMaintenance() && this.isLive) return;

    if (this.pmbonusView) {
      this.pmbonusView.remove();
      this.pmbonusView.unbind();
    }
    this.pmbonusView = new PmangBonusView({ model: this.pmbonus });
    $('.app__pmbonus').html(this.pmbonusView.el);
  },

  isNewUser: function () {
    if (this.state.get('nru')) {
      this.eventBus.trigger('show:newUser');
      return true;
    } else {
      return false;
    }
  },

  checkMaintenance: function (e) {
    if (this.isUnderMaintaining) {
      if (e && _.isFunction(e.preventDefault)) {
        e.preventDefault();
      }
      this.eventBus.trigger('show:maintenance');
      return true;
    } else {
      return false;
    }
  },

  isGuest: function () {
    return this.state.get('guest');
  },

  checkMFA: function () {
    var triggerSuccess = function () {
      $(document).trigger('app:authSuccess');
      return true;
    };

    var triggerFail = function (err) {
      $(document).trigger('app:authFail', { err: err });
      return err;
    };

    return new Promise(
      _.bind(function (resolve, reject) {
        var isMFADeprecated = this.state.checkMFADeprecated();
        var isAuthRequired = this.state.checkMFAActivated();
        var serviceType = this.state.get('mfaServiceType');
        var mfaServiceView;
        var deprecatedError;

        if (isMFADeprecated) {
          deprecatedError = new Error('MFA deprecated');
          deprecatedError.code = ERRORS.MFADeprecated;
          reject(handleError(triggerFail(deprecatedError)));
          return;
        }

        if (!isAuthRequired) {
          // 다른 모듈에서 pub/sub를 프라미스로 래핑해서 결과를 받을 경우, 살짝 지연하지 않으면 subscribe 하기 전에 resolve 된다.
          _.delayed(function () {
            resolve(triggerSuccess());
          }, 10);
          return;
        }

        if (serviceType === 'PASSWD') {
          mfaServiceView = new PasswdView({
            model: new PasswdModel()
          });
        } else if (serviceType === 'SMS') {
          mfaServiceView = new SecureSMSView({
            model: new SecureSMSModel()
          });
        } else {
          reject(new Error('Unknown MFA Service'));
          return;
        }

        mfaServiceView.on('success', function () {
          mfaServiceView.remove();
          resolve(triggerSuccess());
        });

        mfaServiceView.on('fail', function (e) {
          var err = new Error(e.resultText || 'MFA failed');
          err.code = e.resultCode;
          err.description = e.resultText;
          mfaServiceView.remove();
          reject(handleError(triggerFail(err)));
        });

        $('.app__mfa').html(mfaServiceView.render().el);
      }, this)
    );
  },

  findDefaultGameChannel: function () {
    var $chs = $('[data-channel-id]').filter('[data-app-role=runGame]');
    // 0번은 순서상 자유채널. 가능한 채널 중에 가장 낮은 채널.
    return $chs.eq(1).data('channelLabel');
  },

  runGame: function (e) {
    var gameSSN;
    var gameInfoSrl;
    var channelLabel;
    var $el;

    if (e && _.isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (this.isGuest()) {
      this.login();
      return;
    }

    if (this.checkMaintenance() && this.isLive) return;

    // 윈도우 XP  사용자일 경우 안내 메시지
    var agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf('windows nt 5.1') >= 0) {
      this.message.show('게임 실행 안내', [
        '죄송합니다.',
        '윈도우 XP에서는 게임을 실행하실 수 없습니다.'
      ]);
      return;
    }

    if (e && e.currentTarget) {
      // 링크의 클릭 이벤트로 실행 태그에 dataset 있어야 함
      $el = $(e.currentTarget);
      // data-ssn 값 || 현재 페이지의 SSN
      gameSSN = $el.data('ssn') || this.state.get('ssn');
      // data-game-info-srl 값 || 현재 페이지의 gameInfoSrl
      gameInfoSrl = $el.data('gameInfoSrl') || this.state.get('gameInfoSrl');
      channelLabel = $el.data('channelLabel') || this.findDefaultGameChannel();
    } else if (e && e.ssn) {
      // app:runGame 이벤트를 trigger 하면서 옵션으로 게임 실행
      // 피망 슬롯/베가스의 gameInfoSrl은 무조건 1로 고정
      gameSSN = e.ssn;
      gameInfoSrl = e.gameInfoSrl || 1;
      channelLabel = e.channel || 0;
    } else {
      // 현재 페이지의 게임 실행
      gameSSN = this.state.get('ssn');
      gameInfoSrl = this.state.get('gameInfoSrl');
      channelLabel = this.findDefaultGameChannel();
    }

    // NOTE: 라이브 환경일 경우만 점검 확인
    if (this.state.get('env') === 'live' && this.state.get('maintenanceSsn') === gameSSN) {
      this.message.show('게임 점검 안내', ['지금은 게임 점검 중입니다.', '조금만 기다려 주세요.']);
      return;
    }

    this.checkMFA()
      .then(
        _.bind(function () {
          return gameStarter.fetchParams(this.game, gameSSN, gameInfoSrl, channelLabel);
        }, this)
      )
      .then(gameStarter.launch)
      .then(gameStarter.sendOSInfo)
      .then(function () {
        var launcherType = $.browser.msie ? 'AX' : 'CU';
        if (window.gtag) {
          window.gtag('event', 'click', {
            event_category: 'game_start',
            event_label: 'ssn:' + gameSSN + '_type:' + launcherType
          });
        }
      })
      .catch(handleError);
  },

  showPrelude: function (e) {
    e.preventDefault();

    if (this.isNewUser()) {
      return;
    }

    if (this.isGuest()) {
      this.login();
      return;
    }

    var href = $(e.currentTarget).attr('href').split('/').pop();

    var title = '이벤트 참여';
    var menu = '이벤트';

    if (href === 'Store') {
      title = '상품 구매';
      menu = '상점';
    }

    var showPreludePopup = _.bind(function (isPlaying) {
      this.preludeMessage(isPlaying, title, menu);
    }, this);

    userGameStatus.checkPlaying(this.game).done(showPreludePopup);
  },

  preludeMessage: function (isPlaying, title, menu) {
    if (isPlaying) {
      // prettier-ignore
      this.message.show(
        '게임 실행 안내',
        ["게임이 실행 중입니다.", "상세정보는 게임 내 '" + menu + "' 메뉴에서<br> 확인하실 수 있습니다."]
      );
    } else {
      // prettier-ignore
      this.message.showPrelude([
        title + "는", 
        "<strong>게임실행 &gt; '" + menu + "'</strong> 메뉴에서", 
        "확인하실 수 있습니다."],
        this.runGame
      );
    }
  },

  openWindowPopup: function (e) {
    if (e && _.isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    var $target;
    var dataset;
    var popName;
    var width;
    var height;
    var onClose;
    var scrollbars;
    var href;
    var opened;

    if (e.currentTarget) {
      $target = $(e.currentTarget);
      href = $target.attr('href');
      dataset = $target.data();
      popName = dataset.appPopup;
      width = dataset.appPopupWidth;
      height = dataset.appPopupHeight;
      onClose = dataset.appPopupOnClose;
      scrollbars = dataset.appPopupScrollbars || 'yes';
    } else {
      href = e.href;
      popName = e.name;
      width = e.width;
      height = e.height;
      onClose = e.onClose;
      scrollbars = e.scrollbars || 'yes';
    }

    // 링크에 {gsn} 문자열을 유저의 GSN으로 치환
    var gsn = this.state.get('gsn');
    href = href.replace('{gsn}', gsn);

    opened = openPopup(href, popName, {
      width: width,
      height: height,
      scrollbars: scrollbars
    });

    if (onClose) {
      this.openedPopups.push({
        ref: opened,
        name: popName,
        onClose: onClose
      });

      this.clearWatchPopup();
      this.clearWatchPopup = _.repeat(this.watchPopups, 500);
    }
  },

  watchPopups: function () {
    if (this.openedPopups.length > 0) {
      _.each(
        this.openedPopups,
        _.bind(function (pop, i) {
          if (pop.ref && pop.ref.closed) {
            this.popupOnClose(pop.onClose, i);
          }
        }, this)
      );
    } else {
      this.clearWatchPopup();
    }
  },

  popupOnClose: function (onClose, index) {
    if (_.isFunction(onClose)) {
      onClose.call();
    } else if (_.isString(onClose)) {
      var cbChunk = onClose.split(':'); // app:viewName:eventName 형식
      if (cbChunk[0] === 'app') {
        this[cbChunk[1]].trigger(cbChunk[2]);
      }
    }
    this.openedPopups.splice(index, 1);
  },

  openNewWindow: function (e) {
    e.preventDefault();
    var $el = $(e.currentTarget);
    var href = $el.attr('href');

    // 링크에 {gsn} 문자열을 유저의 GSN으로 치환
    var gsn = this.state.get('gsn');
    href = href.replace('{gsn}', gsn);

    /**
     * NIMS 설정에서 링크를 '웹(외부형)=OW'으로 설정할 경우 새창으로 오픈
     * NL 페이지를 새탭에서 열경우 AX에서 SayR 로그인을 하고,
     * 창을 닫으면 AX에서 로그인 쿠키를 삭제하여 로그인이 풀림
     * Nims에서 NL 페이지는 웹(내부형)=O 로 설정하도록 기획쪽에 가이드 필요
     * 2023.08 : AX 없애서 이제 괜찮으려냐?
     */
    return window.open(href); // 새창(새탭) or window.top.location.href = href // 현재 창
  },

  createLayerPopups: function () {
    var LAST_POP = 'pk_lp_last';
    var pickNextLayerPopup = function (pops) {
      var lastId = cookies.get(LAST_POP);
      var entries = _.filter(pops, function (pop) {
        return pop.get('shouldBeShown'); // 노출 조건을 통과한 팝업 후보들
      });
      var lastIndex = _.findIndex(entries, function (pop) {
        return pop.get('id') === lastId; // 후보 팝업 중 쿠키로 저장된 마지막으로 노출된 팝업
      });

      if (!_.isArray(pops) || entries.length < 1) {
        return null;
      } else if (!lastId) {
        return entries[0];
      } else {
        return entries[lastIndex + 1] || entries[0];
      }
    };
    var entry = null;

    this.$('.app__pmlayer').each(
      _.bind(function (idx, el) {
        var pmlayer = new PmlayerModel(getValueFromPmlayerDOM(el));
        new PmlayerView({ model: pmlayer, el: el });
        this.layerPopups.push(pmlayer);
      }, this)
    );

    entry = pickNextLayerPopup(this.layerPopups);
    if (entry) {
      cookies.set(LAST_POP, entry.get('id'));
      entry.setVisible(true);
    }
  },

  logout: function (e) {
    e.preventDefault();
    location.assign('/logout');
  },

  login: function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    var loginUrl = this.state.get('loginUrl');
    setTimeout(function () {
      location.assign(loginUrl);
    }, 100); // 혹시 몰라서 gtag 이벤트 보낼 시간을 확보
  },

  reportClickAction: function (e) {
    if (!this.state.get('guest')) {
      return;
    }

    var $target = $(e.currentTarget);
    var role = $target.data('app-action') || 'not_set';
    var href = $target.attr('href') || 'not_set';
    var text = $target.text() || $target.attr('class') || 'not_set';
    var label = [text, href].join(':');

    if (typeof gtag === 'function') {
      gtag('event', role, {
        event_category: 'login_action',
        event_label: label
      });
    } else {
      console.log(
        'Failed to send GA event - Category: login_action',
        '/ Action:',
        role,
        '/ Label:',
        label
      );
    }
  }
});
